import {BackButton, typography, ViewHeader, ViewHeaderItem} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

interface CarrierViewHeaderProps {
    onBack: () => void;
    title: string;
    description: string;
}


export function CarrierViewHeader({onBack, title, description}: CarrierViewHeaderProps) {
    const {t} = useLocalization();
    return (
        <ViewHeader className={styles.viewHeader}>
            {onBack && (
                <ViewHeaderItem>
                    <BackButton onClick={onBack} label={t("Back")}/>
                </ViewHeaderItem>
            )}
            <ViewHeaderItem fill>
                <div className={typography.title}>
                    {title}
                </div>
                <div className={typography.description}>
                    {description}
                </div>
            </ViewHeaderItem>
        </ViewHeader>
    )
}


export const styles = stylesheet({
    viewHeader: {
        background: "var(--color-primary)",
        color: "#fff",
        boxShadow: "0 0.1em 0.3em -0.1em rgba(0, 0, 0, 0.5)",
        zIndex: 1,
    }
})